<header>
  <div class="container">
    <div class="row">
      <div class="col">
        <img height="40" src="./assets/logo_light.svg" alt="">
      </div>
    </div>
  </div>
</header>
<div class="container">
  <div class="row brow">
    <div class="col-sm-6 pt-3 pb-3">
      <h1>Pensando en una mejor experiencia de navegación</h1>
      <h5 class="mt-3 mb-4">te recomendamos usar <b>Google Chrome</b></h5>
      <div class="mt-4">
        <a href="https://www.google.com/chrome/" class="btn btn-success">Descargar Google Chrome</a>
      </div>      
    </div>
  </div>
</div>